// 获取快讯列表
export const GETFLASHLIST = 'get-flash-list'

// 获取更多快讯
export const GETMOREFLASH = 'get-more-flash'

// 快讯利好利空
export const FLASHUPDOWN = 'flash-up-down'
